export default "f7d4db78b4001d52.svg"